module.exports = __webpack_public_path__ + "img/2.3ef785f7.jpg";